import React, { memo } from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { Stepper } from '../../material-ui/Stepper';
import { useStyles } from './useStyles';
import { FlightWizardStep } from './FlightWizardStep/FlightWizardStep';
import { wizardSteps } from '../tools';
import { getCurrentSendedLeg } from '../../../selectors/sended-data';
import { MobileWizardStepper } from './MobileWizardStepper/MobileWizardStepper';

export const FlightWizardStepper = memo(({ activeStep }) => {
    const classes = useStyles();
    const isMobile = useMediaQuery('(max-width: 660px)');
    const isNextStepDisabled = useSelector((state) => {
        const leg = getCurrentSendedLeg(state);
        const takeOff = get(leg, 'takeOff', {});
        const ofpId = get(leg, 'ofpId');
        const isNextStepDisabled = !ofpId || !takeOff.startWorkTime;

        return isNextStepDisabled;
    });
    const { t: translate } = useTranslation();

    return (
        <div className={classes.stepperWrapper}>
            <Stepper activeStep={activeStep} className={classes.stepper} nonLinear={true}>
                {!isMobile ? (
                    wizardSteps.map(({ number, name, checkDisable }) => (
                        <FlightWizardStep
                            key={number}
                            index={number}
                            name={translate(name)}
                            disabled={checkDisable && isNextStepDisabled}
                        />
                    ))
                ) : (
                    <MobileWizardStepper isNextStepDisabled={isNextStepDisabled} />
                )}
            </Stepper>
        </div>
    );
});
